/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
document.addEventListener('DOMContentLoaded', function() {
	const accordionItems = document.querySelectorAll('.js-accordion-item-trigger');

	accordionItems.forEach(item => {
		item.addEventListener('click', function() {
			// Check if the clicked item is already active
			const isActive = this.parentElement.classList.contains('is-active');

			// Remove 'is-active' from all items
			accordionItems.forEach(i => {
				i.parentElement.classList.remove('is-active');
			});

			// Toggle the class 'is-active' on the clicked item only if it was not active
			if (!isActive) {
				this.parentElement.classList.add('is-active');
			}
		});
	});
});

/* eslint-enable no-console */
